// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-message {
  width: 100%;
  height: calc(100% - 1.3125rem);
  overflow-x: hidden;
  overflow-y: scroll;
  border-radius: 0.05rem;
}
.chat-message::-webkit-scrollbar {
  width: 0;
  height: 0;
}
.chat-message-item {
  min-height: 0.1875rem;
  width: 100%;
  align-items: center;
  border-radius: 0.05rem;
  font-size: 0.075rem;
  margin-top: 0.0625rem;
  color: #333;
  position: relative;
}
.chat-message-item-scroll {
  padding: 0.0625rem;
}
.chat-message-item-user {
  background-color: #f4ede6;
  color: #333;
}
.chat-message-item-user div {
  width: 100%;
}
.chat-message-item-user div .text-only {
  width: 100%;
  font-size: 0.0875rem;
  overflow-wrap: break-word;
  white-space: pre-wrap !important;
}
.chat-message-item-user .toggle-button {
  width: 100%;
  height: 0.1625rem;
  background: rgba(218, 202, 190, 0.4);
  font-size: 0.075rem;
  position: sticky;
  bottom: -0.0125rem;
  margin-bottom: 0.03125rem;
  padding: 0 0.0625rem;
  display: flex;
  justify-content: flex-end;
  border-radius: 0 0 0.0625rem 0.0625rem;
}
.chat-message-item-user .toggle-button .anticon {
  color: #8c8c8c;
  cursor: pointer;
}
.chat-message-item-user .toggle-button .anticon:hover {
  transform: scale(1.3);
}
.chat-message-item-user .chat-message-item-text {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-height: 0.375rem;
  line-height: 0.125rem;
  transition: max-height 500ms ease, opacity 500ms ease;
}
.chat-message-item-user .chat-message-item-text-expand {
  max-height: 6.25rem;
  opacity: 1;
  overflow: auto;
}
.chat-message-item-user .chat-message-item-text-expand::-webkit-scrollbar {
  width: 0;
  height: 0;
}
.chat-message-item-ai {
  background-color: rgba(152, 182, 177, 0.4);
  min-height: 0.25rem;
  overflow: hidden;
}
.chat-message-item-ai .inline-box {
  display: flex;
  align-items: center;
}
.chat-message-item-ai .status {
  margin-right: 0.0625rem;
  background: linear-gradient(90deg, rgba(28, 165, 175, 0.5), rgba(50, 92, 239, 0.5), rgba(246, 144, 30, 0.6), rgba(0, 0, 0, 0.7));
  background-clip: text;
  color: transparent;
  white-space: nowrap;
  overflow: hidden;
  font-weight: bold;
  margin-right: 0.03125rem;
}
.chat-message-item-ai .chat-loading {
  max-width: 0.1875rem;
}
.chat-message-item-ai .chat-message-item-text {
  line-height: normal;
}
.chat-message-item img {
  max-width: 1.25rem;
}
.chat-message-item .delete-button {
  display: none;
}
.chat-message-item .cur-chat-dom {
  width: 100%;
  display: flexbox;
  font-family: Roboto-Regular;
  font-size: 0.075rem;
  width: 100%;
  line-height: 0.1375rem;
}
.chat-message-item .cur-chat-dom-btn {
  display: flex;
  margin: 0.0625rem 0 0.03125rem 0;
}
.chat-message-item .cur-chat-dom-btn .continue-ask {
  cursor: pointer;
  width: 0.15625rem;
  height: 0.15625rem;
  border-radius: 0.03125rem;
  border: 0.00625rem solid var(--var-prismer-color1);
  display: flex;
  justify-content: center;
  margin-right: 0.0625rem;
}
.chat-message-item .cur-chat-dom-btn .continue-ask svg {
  fill: var(--var-prismer-color1);
}
.chat-message-item .cur-chat-dom .ant-image {
  margin-right: 0.0625rem;
  max-width: 0.15625rem;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.chat-message-item .cur-chat-dom-test {
  color: #5464a0;
}
.chat-message-item .cur-chat-dom a {
  display: block;
  color: rgb(102, 153, 0);
}
.chat-message-item .test-tip {
  font-weight: bold;
  font-size: 0.0875rem;
  color: #5464a0;
  line-height: 0.25rem;
}`, "",{"version":3,"sources":["webpack://./src/pages/home/component/chatMessage/index.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,8BAAA;EACA,kBAAA;EACA,kBAAA;EACA,sBAAA;AACF;AAAE;EACE,QAAA;EACA,SAAA;AAEJ;AAAE;EACE,qBAAA;EACA,WAAA;EACA,mBAAA;EACA,sBAAA;EACA,mBAAA;EACA,qBAAA;EACA,WAAA;EACA,kBAAA;AAEJ;AADI;EACE,kBAAA;AAGN;AADI;EACE,yBAAA;EACA,WAAA;AAGN;AAFM;EACE,WAAA;AAIR;AAHQ;EACE,WAAA;EACA,oBAAA;EACA,yBAAA;EACA,gCAAA;AAKV;AAFM;EACE,WAAA;EACA,iBAAA;EACA,oCAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,oBAAA;EACA,aAAA;EACA,yBAAA;EACA,sCAAA;AAIR;AAHQ;EACE,cAAA;EACA,eAAA;AAKV;AAJU;EACE,qBAAA;AAMZ;AAFM;EACE,oBAAA;EACA,4BAAA;EACA,gBAAA;EACA,oBAAA;EACA,qBAAA;EACA,qDACE;AAGV;AADQ;EACE,mBAAA;EACA,UAAA;EACA,cAAA;AAGV;AAFU;EACE,QAAA;EACA,SAAA;AAIZ;AACI;EACE,0CAAA;EACA,mBAAA;EACA,gBAAA;AACN;AAAM;EACE,aAAA;EACA,mBAAA;AAER;AAAM;EACE,uBAAA;EACA,gIAAA;EAOA,qBAAA;EACA,kBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,wBAAA;AAJR;AAMM;EACE,oBAAA;AAJR;AAMM;EACE,mBAAA;AAJR;AAOI;EACE,kBAAA;AALN;AAOI;EACE,aAAA;AALN;AAOI;EACE,WAAA;EACA,gBAAA;EACA,2BAAA;EACA,mBAAA;EACA,WAAA;EACA,sBAAA;AALN;AAMM;EACE,aAAA;EACA,gCAAA;AAJR;AAKQ;EACE,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kDAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;AAHV;AAIU;EACE,+BAAA;AAFZ;AAMM;EACE,uBAAA;EACA,qBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;AAJR;AAMM;EACE,cAAA;AAJR;AAMM;EACE,cAAA;EACA,uBAAA;AAJR;AAOI;EACE,iBAAA;EACA,oBAAA;EACA,cAAA;EACA,oBAAA;AALN","sourcesContent":[".chat-message {\n  width: 100%;\n  height: calc(100% - 210px);\n  overflow-x: hidden;\n  overflow-y: scroll;\n  border-radius: 8px;\n  &::-webkit-scrollbar {\n    width: 0;\n    height: 0;\n  }\n  &-item {\n    min-height: 30px;\n    width: 100%;\n    align-items: center;\n    border-radius: 8px;\n    font-size: 12px;\n    margin-top: 10px;\n    color: #333;\n    position: relative;\n    &-scroll {\n      padding: 10px;\n    }\n    &-user {\n      background-color: #f4ede6;\n      color: #333;\n      div {\n        width: 100%;\n        .text-only {\n          width: 100%;\n          font-size: 14px;\n          overflow-wrap: break-word;\n          white-space: pre-wrap !important;\n        }\n      }\n      .toggle-button {\n        width: 100%;\n        height: 26px;\n        background: rgba(218, 202, 190, 0.4);\n        font-size: 12px;\n        position: sticky;\n        bottom: -2px;\n        margin-bottom: 5px;\n        padding: 0 10px;\n        display: flex;\n        justify-content: flex-end;\n        border-radius: 0 0 10px 10px;\n        .anticon {\n          color: #8c8c8c;\n          cursor: pointer;\n          &:hover {\n            transform: scale(1.3);\n          }\n        }\n      }\n      .chat-message-item-text {\n        display: -webkit-box;\n        -webkit-box-orient: vertical;\n        overflow: hidden;\n        max-height: 60px;\n        line-height: 20px;\n        transition:\n          max-height 500ms ease,\n          opacity 500ms ease;\n        &-expand {\n          max-height: 1000px;\n          opacity: 1;\n          overflow: auto;\n          &::-webkit-scrollbar {\n            width: 0;\n            height: 0;\n          }\n        }\n      }\n    }\n    &-ai {\n      background-color: rgba(152, 182, 177, 0.4);\n      min-height: 40px;\n      overflow: hidden;\n      .inline-box {\n        display: flex;\n        align-items: center;\n      }\n      .status {\n        margin-right: 10px;\n        background: linear-gradient(\n          90deg,\n          rgba(28, 165, 175, 0.5),\n          rgba(50, 92, 239, 0.5),\n          rgba(246, 144, 30, 0.6),\n          rgba(0, 0, 0, 0.7)\n        );\n        background-clip: text;\n        color: transparent;\n        white-space: nowrap;\n        overflow: hidden;\n        font-weight: bold;\n        margin-right: 5px;\n      }\n      .chat-loading {\n        max-width: 30px;\n      }\n      .chat-message-item-text {\n        line-height: normal;\n      }\n    }\n    img {\n      max-width: 200px;\n    }\n    .delete-button {\n      display: none;\n    }\n    .cur-chat-dom {\n      width: 100%;\n      display: flexbox;\n      font-family: Roboto-Regular;\n      font-size: 12px;\n      width: 100%;\n      line-height: 22px;\n      &-btn {\n        display: flex;\n        margin: 10px 0 5px 0;\n        .continue-ask {\n          cursor: pointer;\n          width: 25px;\n          height: 25px;\n          border-radius: 5px;\n          border: 1px solid var(--var-prismer-color1);\n          display: flex;\n          justify-content: center;\n          margin-right: 10px;\n          svg {\n            fill: var(--var-prismer-color1);\n          }\n        }\n      }\n      .ant-image {\n        margin-right: 10px;\n        max-width: 25px;\n        cursor: pointer;\n        display: flex;\n        align-items: center;\n      }\n      &-test {\n        color: #5464a0;\n      }\n      a {\n        display: block;\n        color: rgb(102, 153, 0);\n      }\n    }\n    .test-tip {\n      font-weight: bold;\n      font-size: 14px;\n      color: #5464a0;\n      line-height: 40px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
